module.exports = __webpack_public_path__ + "img/77@2x.00d29f78.png";